module.exports = __webpack_public_path__ + "img/gyarikon_piros-03.e348c2f0.svg";